module.exports = __webpack_public_path__ + "1bb12f4f/img/mention-icon.8b3452e6.svg";